import React from 'react';
import List from 'devextreme-react/list';
import Button from 'devextreme-react/button';
import './AXPCAssistant.scss';

export default function AXPCChatHistory({ conversations, onConversationSelected, onConversationDeleted }) {
  const renderItem = (item) => {
    const title = item.title || item.lastMessagePreview || 'New Conversation';
    return (
      <div className="chat-history-item">
        <h6
          onClick={() => onConversationSelected(item)}
          style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
          }}
        >
          {title}
        </h6>
        {false && <Button
          icon="trash"
          stylingMode="text"
          onClick={() => onConversationDeleted(item.sessionId)}
        />}
      </div>
    );
  };

  return (
    <List
      dataSource={conversations}
      itemRender={renderItem}
      scrollingEnabled={true}
      noDataText="No conversation history"
    />
  );
}
